import { db } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { StoreType } from 'types/store'
import { fetchStoresAction } from 'reducks/store/actions'

const fetchStores = (isIncludingEvent?: boolean) => {
  let query = db.collection('stores').where('status', 'in', ['public', 'private'])
  query = isIncludingEvent ? query : query.where('is_sacri_station', '==', false)
  return async (dispatch: Dispatch<Action>) => {
    const stores = await query
      .orderBy('name_kana', 'asc')
      .get()
      .then((snapshots) => {
        const _stores: StoreType[] = []
        snapshots.forEach((snapshot) => {
          const data = snapshot.data() as StoreType
          data.store_id = snapshot.id
          _stores.push(data)
        })
        return _stores
      })
    dispatch(fetchStoresAction(stores))
  }
}

export default fetchStores
